import {useImpersonate, usePermissions} from './PermissionProvider';
import {checkIfAuthorized} from './api';

interface SecuredComponentProps {
  children: JSX.Element;
  requiredPermissions: string[];
  adminWithImpersonate?: boolean;
}

const SecuredComponent = ({
    children,
    requiredPermissions,
    adminWithImpersonate = false
}: SecuredComponentProps): JSX.Element | null => {
    const userPermissions = usePermissions();

    const impersonate = useImpersonate();

    const canAdminSee = adminWithImpersonate && impersonate !== null;

    const isAuthorized = checkIfAuthorized(userPermissions, requiredPermissions);

    if (isAuthorized || canAdminSee) {
        return children;
    }

    return null;
};

export default SecuredComponent;
